import type { ReactNode } from 'react';

export interface ProductNotice {
  id: string;
  /** Text on the pill badge shown under the product title. */
  label: string;
  /** Modal heading. */
  modalTitle: string;
  /** Modal body. */
  content: ReactNode;
}

const H3_CLASS =
  'mt-[18px]! mr-0! mb-2! ml-0! text-[16px] font-semibold leading-[22px] text-[#141415]';
const P_CLASS =
  'mt-0! mr-0! mb-3! ml-0! text-pretty text-[16px] leading-[22px] text-[#141415]';
const UL_CLASS =
  'mt-0! mr-0! mb-3! ml-0! flex list-disc! flex-col gap-1.5 pl-[22px]!';
const LI_CLASS = 'list-disc! text-[16px] leading-[22px] text-[#141415]';

export const PRODUCT_NOTICES: ProductNotice[] = [
  {
    id: 'warranty',
    label: 'Гарантия и возврат',
    modalTitle: 'Гарантия и возврат',
    content: (
      <>
        <h3 className={H3_CLASS}>Передумали?</h3>
        <p className={P_CLASS}>
          Вы можете вернуть товар в течение 7 дней с момента получения, в
          случае, если заводская упаковка не была вскрыта.
        </p>
        <h3 className={H3_CLASS}>Получили товар с заводским браком?</h3>
        <p className={P_CLASS}>
          Мы предоставляем гарантию качества. Если вы обнаружили
          производственный дефект, свяжитесь с нашей службой поддержки — мы
          сообщим адрес сервисного центра для проверки товара.
        </p>
        <p className={P_CLASS}>
          Если по результатам диагностики будет подтверждён заводской брак, мы:
        </p>
        <ul className={UL_CLASS}>
          <li className={LI_CLASS}>
            полностью компенсируем стоимость товара или
          </li>
          <li className={LI_CLASS}>
            предложим замену (если товар есть в наличии).
          </li>
        </ul>
        <p className={P_CLASS}>
          Если у вас возникли вопросы по возврату или гарантии, пожалуйста,
          свяжитесь с нашей службой поддержки — мы обязательно поможем.
        </p>
      </>
    ),
  },
  {
    id: 'imported',
    label: 'Товар из-за границы',
    modalTitle: 'Товар из-за границы',
    content: (
      <>
        <p className={P_CLASS}>
          Товар отгружается из-за границы. Срок доставки составляет 5–15 рабочих
          дней.
        </p>
        <p className={P_CLASS}>
          Согласно таможенным правилам, для оформления доставки необходимо:
        </p>
        <ul className={UL_CLASS}>
          <li className={LI_CLASS}>
            Указать полное ФИО получателя при оформлении заказа;
          </li>
          <li className={LI_CLASS}>
            Предоставить паспортные данные и ИНН таможенному брокеру после
            оформления заказа.
          </li>
        </ul>
        <p className={P_CLASS}>
          После оформления заказа таможенный брокер направит вам email или SMS с
          инструкциями для заполнения необходимых данных.
        </p>
        <p className={P_CLASS}>
          При получении заказа паспорт предъявлять не требуется — доставка
          осуществляется в постаматы.
        </p>
      </>
    ),
  },
];
